const sendRollbarError = (...args) => {
  if (!globalThis.Rollbar || !args.length) return;

  globalThis.Rollbar.error(...args);
};

export default sendRollbarError;
